import { render } from "./BabyNoteMain.vue?vue&type=template&id=4d04e9ce"
import script from "./BabyNoteMain.vue?vue&type=script&lang=js"
export * from "./BabyNoteMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__